import "./button.scss";

interface IButton extends React.ComponentProps<"button"> {
  variant: "primary" | "secondary";
  text: string;
  icon: string;
}

const Button = ({ variant, text, icon, ...props }: IButton) => {
  return (
    <button className={`button button__${variant}`} {...props}>
      {text}
      <i>{icon}</i>
    </button>
  );
};

export default Button;
